import { styled } from '@mui/material/styles';
import { Button as BaseButton } from '@mui/material';

export const Button = styled(BaseButton)(({ theme }) => ({
  height: 70,
  backgroundColor: theme.palette.background.paper,
  boxShadow: '0px 3px 6px #00000029',
  fontWeight: 'bold',
  padding: theme.spacing(2),
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'flex-start',
    padding: theme.spacing(3),
    borderRadius: 28,
    height: 110,
  },
}));
